<div class="root" (click)="matDialogRef.close()" aria-label="Close dialog">
  <div *ngFor="let member of data" class="mt-4" fxLayout="column">
    <div fxLayout="row">
      <div>
        <img
          (error)="$event.target.src = '/assets/images/empty_profile_male.jpg'"
          class="member-photo"
          src="{{ member.photo_url }}"
        />
      </div>
      <div fxLayout="column">
        <div class="name" style="color: #039be5">{{ member_name }}</div>
        <a href="javascript:void(0);"
          ><div (click)="memberView(member)" class="member_id">
            <span style="color: green"> ID:</span> #{{ member_id }}
          </div></a
        >
        <div class="contact">
          <a href="tel:{{ member.contact }}"
            ><mat-icon style="color: green">phone</mat-icon>
            {{ member_contact }}</a
          >
        </div>
      </div>
    </div>
    <div class="divider m-4"></div>
  </div>
</div>
